import * as Yup from 'yup';

import { outletsValidations } from './addMerchantStep4';

export const addMerchantValidation = (serviceType) => {
    return Yup.object().shape({
        aboutBusiness: Yup.object().shape({
            businessType: Yup.string()
                .when(['isCharity'], {
                    is: (isCharity) => {
                        return isCharity === false;
                    },
                    then: Yup.string().required('Select Business Type').nullable(),
                })
                .nullable(),
            legalCompanyName: Yup.string().required('Enter a Legal Company Name'),
            serviceType: Yup.string(),
            website: Yup.string().when('serviceType', {
                is: () => {
                    return serviceType === 'ONLINE';
                },
                then: Yup.string()
                    .url('URL must be in the format https://www.example.com')
                    .required('URL is required'),
                otherwise: Yup.string().url('URL must be in the format https://www.example.com'),
            }),
            registeredNumber: Yup.string()
                .when(['businessType'], {
                    is: (businessType) => {
                        return businessType !== 'PARTNERSHIP' && businessType !== 'SOLE_TRADER';
                    },
                    then: Yup.string().required('Registration number is required').nullable(),
                })
                .nullable(),
            tradingName: Yup.string().required('Enter Trading Name'),
            isCharity: Yup.boolean(),
            charityNumber: Yup.string()
                .when(['isCharity'], {
                    is: (isCharity) => {
                        return isCharity === true;
                    },
                    then: Yup.string().required('Enter Charity Number').nullable(),
                })
                .nullable(),
            registeredAddress: Yup.object().shape({
                eircode: Yup.string().required('Required'),
                addressLine1: Yup.string().required('Required'),
                townOrCity: Yup.string().required('Required'),
                country: Yup.string().required('Required'),
                county: Yup.string().required('Required'),
            }),
            vat: Yup.object().shape({
                vatRegistered: Yup.boolean(),
                vatNumber: Yup.string().when(['vatRegistered'], {
                    is: (vatRegistered) => {
                        return vatRegistered === true;
                    },
                    then: Yup.string()
                        .required('Enter a valid VAT number')
                        .matches(
                            /^[A-Za-z0-9]+$/,
                            'VAT number must not contain spaces or special characters'
                        )
                        .nullable(),
                }),
            }),
        }),
        outlets: outletsValidations,
        numberOfOutlets: Yup.number()
            .min(1, 'Must be at least 1 outlet')
            .max(1000, 'Must be less that 1000')
            .notRequired(),
        principals: Yup.array().of(principalValidationSchema),
    });
};

export const personalInfoValidationSchema = Yup.object().shape({
    firstName: Yup.string().required('Required'),
    lastName: Yup.string().required('Required'),
    middleNames: Yup.string(),
    dateOfBirth: Yup.string().required('Required'),
    nationality: Yup.string().required('Required'),
    email: Yup.string()
        .email('Enter a valid email address')
        .required('Enter a valid email address'),
    mobileNumber: Yup.string(),
    telephoneNumber: Yup.string(),
});

export const principalValidationSchema = personalInfoValidationSchema.concat(
    Yup.object().shape({
        percentageOfOwnership: Yup.number()
            .min(0, 'Percentage of ownership must be 0% or greater')
            .max(100, 'Percentage of ownership may not exceed 100%')
            .required('Required'),
        position: Yup.string().required('Required'),
        addresses: Yup.array().of(
            Yup.object().shape({
                eircode: Yup.string().required('Required'),
                type: Yup.string().oneOf(['PERSONAL_ADDRESS', 'PREVIOUS_ADDRESS']),
                addressLine1: Yup.string().required('Required'),
                addressLine2: Yup.string(),
                city: Yup.string().required('Required'),
                county: Yup.string().required('Required'),
                country: Yup.string().required('Required'),
                timeAtAddress: Yup.object().shape({
                    years: Yup.number().required('Required'),
                    months: Yup.number().required('Required'),
                }),
            })
        ),
    })
);
